// @ts-strict-ignore
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { AdminService } from 'src/app/services/admin.service';

@Component({
  selector: 'admin-blotter',
  templateUrl: './admin-blotter.component.html',
})
export class AdminBlotterComponent implements OnInit, OnDestroy {
  private pageClosed = new Subject<void>();
  public paramsPartyType: string;
  private readonly router = inject(Router);
  private readonly activatedRoute = inject(ActivatedRoute);

  constructor(private readonly adminService: AdminService) {}
  public ngOnInit() {
    this.adminService
      .setHeaderForAdmin()
      .pipe(takeUntil(this.pageClosed))
      .subscribe(() => {
        this.paramsPartyType = sessionStorage.getItem('selectedEntityType');
        if (this.paramsPartyType === 'member') {
          setTimeout(() => {
            this.router.navigate(['./blotter'], {
              relativeTo: this.activatedRoute,
              queryParamsHandling: 'preserve',
            });
          });
        }
        if (this.paramsPartyType === 'credit_bank') {
          setTimeout(() => {
            this.router.navigate(['./pricer'], {
              relativeTo: this.activatedRoute,
              queryParamsHandling: 'preserve',
            });
          });
        }
      });
  }
  public ngOnDestroy() {
    this.pageClosed.next();
    this.pageClosed.complete();
  }
}
